module.exports = __webpack_public_path__ + "img/album15_12.fdcca37b.jpg";